module.exports = __webpack_public_path__ + "static/media/devices-asset.58dd41b8.png";